import React from "react";
import { Box, Grid, Paper, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const formatBytes = (n) => {
  if (typeof n !== "number" || !Number.isFinite(n)) return "—";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v >= 10 ? 0 : 1)} ${units[i]}`;
};

const StatCard = ({ title, value, loading }) => (
  <Paper variant="outlined" sx={{ p: 2 }}>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
      {title}
    </Typography>
    {loading ? (
      <Skeleton variant="text" width={120} height={32} />
    ) : (
      <Typography variant="h6" sx={{ fontWeight: 800 }}>
        {value}
      </Typography>
    )}
  </Paper>
);

export default function AdminBillingTotals({ totals, loading }) {
  const { t } = useTranslation();

  const runsTotal = totals?.runs_total ?? 0;
  const pagesTotal = totals?.pages_total ?? 0;
  const anonymizedTotal = totals?.anonymized_total ?? 0;
  const inBytes = totals?.input_bytes_total ?? 0;
  const outBytes = totals?.output_bytes_total ?? 0;

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1 }}>
        {t("adminBilling.totals.title", "Súhrn")}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title={t("adminBilling.totals.runs", "Počet behov")} value={runsTotal} loading={loading} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard title={t("adminBilling.totals.pages", "Strany")} value={pagesTotal} loading={loading} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard title={t("adminBilling.totals.items", "Zásahy")} value={anonymizedTotal} loading={loading} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard title={t("adminBilling.totals.input", "Vstup")} value={formatBytes(inBytes)} loading={loading} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StatCard title={t("adminBilling.totals.output", "Výstup")} value={formatBytes(outBytes)} loading={loading} />
        </Grid>
      </Grid>
    </Box>
  );
}